/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useContext, useState } from "react"
import { AppFunctionComponent } from "../types"

const MouseContext = createContext({
  isMouseInHeader: false,
  handleMouseEnter: () => {},
  handleMouseLeave: () => {},
})

export const MouseProvider: AppFunctionComponent = ({ children }) => {
  const [isMouseInHeader, setIsMouseInHeader] = useState(false)

  const handleMouseEnter = () => {
    setIsMouseInHeader(true)
  }

  const handleMouseLeave = () => {
    setIsMouseInHeader(false)
  }

  const value = {
    isMouseInHeader,
    handleMouseEnter,
    handleMouseLeave,
  }

  return <MouseContext.Provider value={value}>{children}</MouseContext.Provider>
}

export const useMouseHook = () => {
  return useContext(MouseContext)
}
